import Analytics from './Analytics.vue';
import AnalyticsProjeto from './compartilhado/AnalyticsProjeto.vue';

export default {
  path: '/analytics',
  component: Analytics,
  name: 'analytics',
  meta: { auth: true },
  children: [
    {
      path: 'projeto',
      component: AnalyticsProjeto,
      name: 'analytics-projeto',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/analytics/rotas.js